(() => {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const revealSelector = '[data-wei-reveal]';
  const heroSelector = '[data-wei-hero]';
  const pending = new Set();
  let observer;

  const collect = (scope, selector) => {
    const elements = [];
    if (scope instanceof Element && scope.matches(selector)) elements.push(scope);
    if (scope.querySelectorAll) elements.push(...scope.querySelectorAll(selector));
    return elements;
  };

  const show = (element) => {
    element.classList.add('is-visible');
    pending.delete(element);
    observer?.unobserve(element);
  };

  const prepareHeroes = (scope = document) => {
    collect(scope, heroSelector).forEach((hero) => {
      hero.querySelectorAll('[data-wei-hero-step]').forEach((step, index) => {
        step.style.setProperty('--wei-hero-order', Math.min(index, 6));
      });
    });
  };

  const getObserver = () => {
    if (observer) return observer;

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) show(entry.target);
        });
      },
      { rootMargin: '0px 0px -7% 0px', threshold: 0.1 }
    );

    return observer;
  };

  const setRevealOrder = (elements) => {
    const groups = new Map();

    elements.forEach((element) => {
      const group = element.closest('.shopify-section, .wei-section, main') || document.body;
      const groupElements = groups.get(group) || [];
      groupElements.push(element);
      groups.set(group, groupElements);
    });

    groups.forEach((groupElements) => {
      groupElements.forEach((element, index) => {
        element.style.setProperty('--wei-reveal-order', Math.min(index, 4));
      });
    });
  };

  const observe = (scope = document) => {
    const elements = collect(scope, revealSelector).filter((element) => !element.classList.contains('is-visible'));
    if (!elements.length) return;

    if (reduceMotion.matches || !('IntersectionObserver' in window) || window.Shopify?.designMode) {
      elements.forEach(show);
      return;
    }

    setRevealOrder(elements);
    const revealObserver = getObserver();
    elements.forEach((element) => {
      pending.add(element);
      revealObserver.observe(element);
    });
  };

  const initialize = (scope = document) => {
    prepareHeroes(scope);
    observe(scope);
  };

  const safeInitialize = (scope = document) => {
    try {
      initialize(scope);
    } catch {
      collect(scope, revealSelector).forEach(show);
    }
  };

  prepareHeroes(document);
  root.classList.add('wei-motion-ready');
  safeInitialize(document);

  reduceMotion.addEventListener('change', (event) => {
    if (!event.matches) return;
    pending.forEach(show);
    observer?.disconnect();
    observer = undefined;
  });

  document.addEventListener('shopify:section:load', (event) => safeInitialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    collect(event.target, revealSelector).forEach((element) => {
      pending.delete(element);
      observer?.unobserve(element);
    });
  });
})();
